module.exports = __webpack_public_path__ + "static/media/photo4@2x.3d203a85.jpg";